import { Feedback as FeedbackIcon } from '@mui/icons-material';
import { Button, Divider, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { useState } from 'react';
import { FeedbackPanel } from '../AppBar/FeedbackPanel';

const useStyles = makeStyles(theme => ({
  button: {
    width: '100%',
    padding: '6px 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.baseColors.deepSeaNavy.c100,

    '&.MuiButton-sizeMedium > .MuiButton-icon': {
      padding: '9px',
      borderRadius: '50px',
    },
  },
  trainingButton: {
    marginTop: '1em',
    marginBottom: '1em',
    '&.MuiButton-sizeMedium > .MuiButton-icon': {
      background: theme.palette.baseColors.deepSeaNavy.c100,
      color: theme.palette.baseColors.white.c100,
    },
  },
  chatButton: {
    color: theme.palette.baseColors.fireOrange.c100,
    '&.MuiButton-sizeMedium > .MuiButton-icon': {
      ...theme.palette.actionCustom,
    },
  },
  info: {
    textTransform: 'none',
  },
  contact: {
    ...theme.palette.accentText,
    fontSize: '10px',
  },
}));

const Support = () => {
  const classes = useStyles();
  const [openFeedbackPanel, setOpenFeedbackPanel] = useState(false);

  return (
    <div>
      <Divider />
      <Button
        className={clsx(classes.button, classes.trainingButton)}
        onClick={() => setOpenFeedbackPanel(true)}
        endIcon={<FeedbackIcon />}
      >
        <Typography fontWeight='medium'>Give Feedback</Typography>
      </Button>
      <FeedbackPanel open={openFeedbackPanel} onClose={() => setOpenFeedbackPanel(false)} />
    </div>
  );
};

export default Support;
